var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3236 3.01562H3.76938C3.16956 3.01562 2.5943 3.2539 2.17017 3.67804C1.74603 4.10218 1.50775 4.67743 1.50775 5.27725V12.816C1.50775 13.4158 1.74603 13.9911 2.17017 14.4152C2.5943 14.8394 3.16956 15.0776 3.76938 15.0776H14.3236C14.9235 15.0776 15.4987 14.8394 15.9229 14.4152C16.347 13.9911 16.5853 13.4158 16.5853 12.816V5.27725C16.5853 4.67743 16.347 4.10218 15.9229 3.67804C15.4987 3.2539 14.9235 3.01563 14.3236 3.01562ZM3.76938 4.52338H14.3236C14.5236 4.52338 14.7153 4.6028 14.8567 4.74418C14.9981 4.88556 15.0775 5.07731 15.0775 5.27725L9.04651 8.95617L3.0155 5.27725C3.0155 5.07731 3.09493 4.88556 3.23631 4.74418C3.37769 4.6028 3.56944 4.52338 3.76938 4.52338ZM15.0775 12.816C15.0775 13.016 14.9981 13.2077 14.8567 13.3491C14.7153 13.4905 14.5236 13.5699 14.3236 13.5699H3.76938C3.56944 13.5699 3.37769 13.4905 3.23631 13.3491C3.09493 13.2077 3.0155 13.016 3.0155 12.816V6.99609L8.6545 10.4413C8.7691 10.5075 8.8991 10.5423 9.03143 10.5423C9.16377 10.5423 9.29377 10.5075 9.40837 10.4413L15.0775 6.99609V12.816Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnW);
export default __webpack_public_path__ + "static/media/en-w.4dcba26962ed4024b0bfcf057646c543.svg";
export { ForwardRef as ReactComponent };